import { markRaw } from 'vue';

const frontendApps = [];

function normalizeFrontendApp(appConfig, schema) {
  return {
    id: appConfig.id ?? `frontend-${appConfig.name}`,
    name: appConfig.name,
    version: appConfig.version ?? '1.0.0',
    hash: appConfig.hash ?? '',
    type: appConfig.type ?? 'importer',
    title: appConfig.title ?? appConfig.name,
    author: appConfig.author ?? '',
    docs: appConfig.docs ?? '',
    description: appConfig.description ?? '',
    date: appConfig.date ?? new Date().toISOString(),
    runs: appConfig.runs ?? 0,
    price: appConfig.price ?? 0,
    image: appConfig.image ?? '',
    schema: Array.isArray(schema) ? schema : [],
    component: appConfig.component ? markRaw(appConfig.component) : null,
    actionLabel: appConfig.actionLabel ?? 'Start App',
    permission: appConfig.permission ?? '',
    is_hidden: appConfig.is_hidden ?? false,
    user_launchable: appConfig.user_launchable ?? true,
    source: 'frontend',
  };
}

function registerApp(appConfig, schema) {
  frontendApps.push(normalizeFrontendApp(appConfig, schema));
}

function listFrontendApps(filter = {}) {
  return frontendApps.filter((app) => {
    if (filter.type && app.type !== filter.type) return false;
    if (filter.name && !String(app.name).toLowerCase().includes(String(filter.name).toLowerCase())) return false;
    if (filter.title && !String(app.title).toLowerCase().includes(String(filter.title).toLowerCase())) return false;
    if (filter.author && !String(app.author).toLowerCase().includes(String(filter.author).toLowerCase())) return false;
    return !app.is_hidden;
  });
}

function getFrontendAppByName(name) {
  return frontendApps.find((app) => app.name === name) ?? null;
}

function getFrontendAppsSummary() {
  const byType = new Map();

  for (const app of frontendApps) {
    if (app.is_hidden) continue;

    if (!byType.has(app.type)) {
      byType.set(app.type, {
        type: app.type,
        description: '',
        count: 0,
        free: 0,
        authors: [],
      });
    }

    const entry = byType.get(app.type);
    entry.count += 1;
    if ((app.price ?? 0) <= 0) entry.free += 1;
    if (app.author && !entry.authors.includes(app.author)) {
      entry.authors.push(app.author);
    }
    if (!entry.description && app.description) {
      entry.description = app.description;
    }
  }

  return {
    types: Array.from(byType.values()),
  };
}

import { appSchema as DarknetImporterSchema } from './DarknetImporter/schema.js';
import { appConfig as DarknetImporterConfig } from './DarknetImporter/config.js';
import { appSchema as ImageImporterSchema } from './ImageImporter/schema.js';
import { appConfig as ImageImporterConfig } from './ImageImporter/config.js';

registerApp(DarknetImporterConfig, DarknetImporterSchema);
registerApp(ImageImporterConfig, ImageImporterSchema);

export {
  frontendApps,
  registerApp,
  listFrontendApps,
  getFrontendAppByName,
  getFrontendAppsSummary,
};
